module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvY29zdGFsLTEtMy4wNWI3N2IzNi5qcGciOw=="